import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDraftOrders, completeDraftOrder, deleteDraftOrder } from './thunk';

interface DraftOrder {
    id: string | number;
    createdAt: string;
}

interface DraftOrdersState {
    orders: DraftOrder[];
    loading: {
        fetchDraftOrders: boolean;
    };
    success: {
        fetchDraftOrders: boolean;
    };
}

const initialState: DraftOrdersState = {
    orders: [],
    loading: {
        fetchDraftOrders: false,
    },
    success: {
        fetchDraftOrders: false,
    },
};

const DraftOrdersSlice = createSlice({
    name: 'draftOrders',
    initialState,
    reducers: {
        addDraftOrder: (state, action: PayloadAction<DraftOrder>) => {
            state.orders.push(action.payload);
        },
        removeDraftOrder: (state, action: PayloadAction<string | number>) => {
            state.orders = state.orders.filter(order => order.id !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchDraftOrders.pending, (state) => {
            state.loading.fetchDraftOrders = true;
            state.success.fetchDraftOrders = false;
        });
        builder.addCase(fetchDraftOrders.fulfilled, (state, action: PayloadAction<{ data: DraftOrder[] }>) => {
            state.orders = action.payload.data;
            state.loading.fetchDraftOrders = false;
            state.success.fetchDraftOrders = true;
        });
        builder.addCase(fetchDraftOrders.rejected, (state) => {
            state.orders = [];
            state.loading.fetchDraftOrders = false;
            state.success.fetchDraftOrders = false;
        });
        builder.addCase(completeDraftOrder.fulfilled, (state, action: PayloadAction<string | number>) => {
            state.orders = state.orders.filter(order => order.id !== action.payload);
        });
        builder.addCase(deleteDraftOrder.fulfilled, (state, action: PayloadAction<string | number>) => {
            state.orders = state.orders.filter(order => order.id !== action.payload);
        });
    },
});

export const { addDraftOrder, removeDraftOrder } = DraftOrdersSlice.actions;
export default DraftOrdersSlice.reducer;
